const shcTexts = {
  '0': 'このサービスの対象年齢は12歳以上です。',
  '1':
    '１．利用者が未成年者である場合、本規約の内容および本サービスの利用に関して予め親権者等法定代理人の同意を得た上で、本サービスを利用するものとします。未成年者である利用者が親権者等法定代理人の同意を得ることなく本サービスを利用した場合、当社は、当該利用者による本サービスの利用にかかる契約を解除し、本サービスの利用を停止することができます。<br />本サービスの利用を開始した時点で未成年者であった利用者が、成年後に本サービスを利用した場合、未成年者であった間の本サービスの利用についてすべて追認したものとみなします。<br />当社は、利用者の年齢に応じて本サービスの一部または全部の利用に制限を加えることがあるものとし、当社が本サービスの利用に制限を加えた場合、利用者は、当該制限に従うものとします。',
  '2':
    '２．アカウントの利用停止措置、プレイデータの修正その他の本規約またはガイドラインに基づいて実施する当社の対応によって、お客様に何らかの影響が生じた場合においても、当社は当該影響につき一切の責任（利用料金の返還または払戻しを行う責任を含みます。以下同じ。）を負いません。',
  '3':
    '３．当社は、天災地変、社会的動乱、ストライキ、火災、停電、通信インフラの停止その他の当社の支配できない事由に起因してお客様に生じる影響について一切の責任を負いません。',
  '4':
    '４．当社は、本サービスおよび本サービス内で当社が提供する情報について、明示・黙示を問わずその完全性、正確性、商品性、特定目的のための適合性、非侵害性その他のいかなる保証（本サービスがいかなる環境下でも利用可能であること、お客様のプレイデータが反映されること、または本サービスに不具合もしくはエラーがないことに関する保証を含みます。）を行わず、また、一切の責任を負いません。',
  '5':
    '５．お客様のご利用通信端末の破損、データ消去、紛失、盗難、端末変更もしくは不具合、ご利用通信端末からのアプリのアンインストール、またはパスワードの公開、紛失もしくは忘却等（パスワードの不設定および設定の不備を含みます。）によって、お客様のアカウントの全部または一部が消失し、またはお客様がアカウントへアクセスできなくなった場合においても、当社は一切の責任を負いません。また、お客様の投稿情報に関する責任はお客様が負うものとし、当社は一切の責任を負いません。',
  '6':
    '６． 当社は、お客様と第三者（他のお客様、アプリストア運営者、決済事業者、本サービス内で表示される広告の広告事業者を含みます。）との間で生じた紛争には関知せず、一切の責任を負いません。また、当社は、第三者の投稿情報、サービス（本サービス内で表示される広告およびその広告の対象となるサービスを含みます。）または行為等について一切の責任を負いません。',
  '7':
    '７．お客様は、本サービスを利用するにあたり、健全な生活環境を乱すような過度の利用を避け、また、お客様の周囲の状況に注意して安全に利用するよう心がけるものとします。当社は、社会通念上適切な範囲を逸脱する本サービスの利用、または本サービスの利用中における事故等によりお客様に生じた社会的、精神的、肉体的な損害について、一切の責任を負いません。',
  '8':
    '８．当社は、お客様に対して適宜情報提供やアドバイスを行うことがありますが、お客様は当該情報やアドバイスをお客様の責任において取扱うものとし、当社はその結果について一切の責任を負いません。',
  '9':
    '９．本サービスは車道で解かなければならない謎は一切ございません。参加中の事故においては一切責任を負いません。',
  '10':
    '１０．ゲーム参加中に万が一、事件・盗難が起こっても当社は一切責任を負いません。'
};

export default {
  disclaimer: {
    heading: '免責事項',
    games: {
      '1': {
        text: shcTexts
      },
      '2': {
        text: shcTexts
      },
      '3': {
        text: {
          '0': 'このサービスの対象年齢は17歳以上です。',
          '1':
            '１．本サービスには、暴力シーンやグロテスクな表現が含まれています。未成年者の方はこのサービスの対象年齢をご確認のうえお楽しみください。また、親権者の皆様におかれましては、成長過程にあるお子様へのご配慮をお願い致します。',
          '2':
            '２．利用者が未成年者である場合、本規約の内容および本サービスの利用に関して予め親権者等法定代理人の同意を得た上で、本サービスを利用するものとします。未成年者である利用者が親権者等法定代理人の同意を得ることなく本サービスを利用した場合、当社は、当該利用者による本サービスの利用にかかる契約を解除し、本サービスの利用を停止することができます。<br />本サービスの利用を開始した時点で未成年者であった利用者が、成年後に本サービスを利用した場合、未成年者であった間の本サービスの利用についてすべて追認したものとみなします。<br />当社は、利用者の年齢に応じて本サービスの一部または全部の利用に制限を加えることがあるものとし、当社が本サービスの利用に制限を加えた場合、利用者は、当該制限に従うものとします。',
          '3':
            '３．アカウントの利用停止措置、プレイデータの修正その他の本規約またはガイドラインに基づいて実施する当社の対応によって、お客様に何らかの影響が生じた場合においても、当社は当該影響につき一切の責任（利用料金の返還または払戻しを行う責任を含みます。以下同じ。）を負いません。',
          '4':
            '４．当社は、天災地変、社会的動乱、ストライキ、火災、停電、通信インフラの停止その他の当社の支配できない事由に起因してお客様に生じる影響について一切の責任を負いません。',
          '5':
            '５．当社は、本サービスおよび本サービス内で当社が提供する情報について、明示・黙示を問わずその完全性、正確性、商品性、特定目的のための適合性、非侵害性その他のいかなる保証（本サービスがいかなる環境下でも利用可能であること、お客様のプレイデータが反映されること、または本サービスに不具合もしくはエラーがないことに関する保証を含みます。）を行わず、また、一切の責任を負いません。',
          '6':
            '６．お客様のご利用通信端末の破損、データ消去、紛失、盗難、端末変更もしくは不具合、ご利用通信端末からのアプリのアンインストール、またはパスワードの公開、紛失もしくは忘却等（パスワードの不設定および設定の不備を含みます。）によって、お客様のアカウントの全部または一部が消失し、またはお客様がアカウントへアクセスできなくなった場合においても、当社は一切の責任を負いません。また、お客様の投稿情報に関する責任はお客様が負うものとし、当社は一切の責任を負いません。',
          '7':
            '７．当社は、お客様と第三者（他のお客様、アプリストア運営者、決済事業者、本サービス内で表示される広告の広告事業者を含みます。）との間で生じた紛争には関知せず、一切の責任を負いません。また、当社は、第三者の投稿情報、サービス（本サービス内で表示される広告およびその広告の対象となるサービスを含みます。）または行為等について一切の責任を負いません。',
          '8':
            '８．お客様は、本サービスを利用するにあたり、健全な生活環境を乱すような過度の利用を避け、また、お客様の周囲の状況に注意して安全に利用するよう心がけるものとします。当社は、社会通念上適切な範囲を逸脱する本サービスの利用、または本サービスの利用中における事故等によりお客様に生じた社会的、精神的、肉体的な損害について、一切の責任を負いません。',
          '9':
            '９．当社は、お客様に対して適宜情報提供やアドバイスを行うことがありますが、お客様は当該情報やアドバイスをお客様の責任において取扱うものとし、当社はその結果について一切の責任を負いません。',
          '10':
            '１０．本サービスは車道で解かなければならない謎は一切ございません。参加中の事故においては一切責任を負いません。',
          '11':
            '１１．ゲーム参加中に万が一、事件・盗難が起こっても当社は一切責任を負いません。'
        }
      },
      '6': {
        text: shcTexts
      },
    }
  }
};
